var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.646 6.819a.5.5 0 0 0-.146.354v1.836a.5.5 0 0 0 .5.5h1.836a.5.5 0 0 0 .354-.147l4.467-4.467a1.798 1.798 0 1 0-2.543-2.544zm.854 1.69v-1.13l4.321-4.32a.798.798 0 1 1 1.13 1.128L8.628 8.51zM2.833 5.667a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 1 0 0-1h-4a2.5 2.5 0 0 0-2.5 2.5v6a2.5 2.5 0 0 0 2.5 2.5h6a2.5 2.5 0 0 0 2.5-2.5V8.333a.5.5 0 0 0-1 0v3.334a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5z",
  clipRule: "evenodd"
})));
export default SvgEditIcon;